import CreateBulkEntities from '../CreateBulkEntities'

const CreateBulkStore = () => {
  return <CreateBulkEntities type="bulkStore" />
}
export default CreateBulkStore
